var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"modal",attrs:{"id":"myModal"}},[_c('img',{staticClass:"modal-content",attrs:{"id":"pop_up_ad","src":_vm.previewUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }